import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { IGTFSTripStopUpsert } from "../../../../interfaces/endpoints/IGTFS.types";
import { createGTFSTripStop } from "../../../../services/GTFS.service";
import TripStopForm from "../TripStopForm";
import { tripStopErrorText } from "../tripStopErrors";

const CreateGTFSTripStop: React.FC = () => {
  const navigate = useNavigate();

  const onSubmit = async (payload: IGTFSTripStopUpsert): Promise<boolean> => {
    try {
      const response = await createGTFSTripStop(payload);
      if (response.status !== 200 && response.status !== 201) {
        toast.error(tripStopErrorText((response as { message?: string }).message, "Ruajtja dështoi"), {
          duration: 3500
        });
        return false;
      }
      toast.success("Ndalesa u shtua");
      // After the submit has settled, so the unsaved-changes prompt lets the redirect through.
      setTimeout(() => navigate("/gtfs/trip-stops", { state: ["Menaxhimi i GTFS", "Ndalesat"] }), 500);
      return true;
    } catch (error) {
      toast.error("Ruajtja dështoi. Ju lutem kontrolloni të dhënat dhe provoni përsëri.");
      console.error("Error creating added stop:", error);
      return false;
    }
  };

  return (
    <>
      <Link
        to="/gtfs/trip-stops"
        state={["Menaxhimi i GTFS", "Ndalesat"]}
        className="flex items-center mb-4 text-primary"
      >
        <ChevronLeftIcon className="w-4 h-4 mr-2" />
        Kthehu tek lista
      </Link>
      <TripStopForm title="Shto ndalesë" onSubmit={onSubmit} />
    </>
  );
};

export default CreateGTFSTripStop;
